import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const ParentAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "What is Practido and how does it help my child?",
      content: `Practido is a smart, modern learning platform built to help students master concepts through practice. Instead of just teaching lessons, it focuses on <b>mock test</b>–based learning, detailed analytics, topic-wise insights, streak tracking, and progress reports. Whether your child uses it as a <u>free mathematics app</u>, an <u>English learning app</u>, or for science & computer skills, Practido turns practice into <u>easy learning</u> with real, measurable improvement.`,
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "Does Practido offer mock tests for Olympiads and school exams?",
      content:
        "Absolutely. Practido includes full-length <b>mock test</b> options for school exams, competitive exams, and even Olympiads. Students preparing for math, science, english and computer Olympiads can take timed model tests, attempt topic-wise quizzes, and download practice sheets to boost accuracy and confidence.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "How does Practido make learning interactive for children?",
      content:
        "Practido transforms traditional studying into <u>interactive learning</u>. Kids get instant results, progress charts, peer comparisons, topic-level insights, real-time monitoring, and even gamified competitions like the Practido Online Olympiad. Learning feels fun, not forced.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "Where can my child practice math problems online?",
      content:
        "Your child can practice unlimited math problems on Practido through topic-based tests, instant feedback, and downloadable practice sheets. Whether they want quick drills or advanced <u>mathematical challenge</u>–level questions, everything is available in one place.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "How can my child score 100% in Olympiad exams?",
      content:
        `Consistent, strategic practice is the secret. Practido helps students score higher with:
          <ul className="faqlist">
          <li>
            Timed mock tests that mimic the real Olympiad format
          </li>
          <li>
            Topic-wise performance insights
          </li>
          <li>
            Daily practice tracking
          </li>
          <li>
            Offline revision PDFs
          </li>
        </ul> 
        `,
    },
    {
      id: "Six",
      ariaExpanded: "false",
      title: "How to prepare my child for Maths Olympiad?",
      content:
        "The ideal approach is to start with topic-wise practice tests regularly using Practido’s <u>free mathematics app</u> tools. Attempt Olympiad-style <b>mock test</b> challenges, analyze mistakes using detailed score reports, revise with practice sheets, and build speed with timed model tests.",
    },
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ParentAccordionPage;
